import * as React from 'react';

export interface SvgIconProps {
  style?: React.CSSProperties;
  height?: string;
  width?: string;
  viewBox?: string;
  className?: string;
  fill?: string;
  preserveAspectRatio?: string;
}

const SvgIcon: React.SFC<SvgIconProps> = ({ style, ...rest }) => (
  <svg
    fill="currentColor"
    preserveAspectRatio="xMidYMid meet"
    {...rest}
    style={{
      verticalAlign: 'middle',
      ...style,
    }}
  />
);

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg/SvgIcon.tsx